import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from '../ui/CtaButton';
const tomos = [{
  icon: '📘',
  title: '01 — Sistema de Anamnesis Pro',
  desc: 'La estructura completa de los primeros 60-90 minutos. Anamnesis, evaluación biopsicosocial, diagnóstico nutricional y plan inicial. Con el guión de cierre para asegurar el próximo turno. Nunca más salís de una primera consulta sin saber exactamente por dónde empezar.'
}, {
  icon: '📗',
  title: '02 — Vademécum de Marcas Argentinas',
  desc: 'Qué comprar en el supermercado argentino. Análisis por categoría de los productos reales que tus pacientes consumen. Con sistema de semáforo, los 5 ingredientes red flag y los 47 nombres del azúcar en las etiquetas. La respuesta concreta a la pregunta que más te van a hacer: "¿Qué marca compro?"'
}, {
  icon: '📙',
  title: '03 — Laboratorios y Clínica para Nutricionistas',
  desc: 'Cómo interpretar un análisis de sangre más allá de los valores del laboratorio. Valores óptimos funcionales para hierro, glucemia, insulina, HOMA-IR, tiroideos, vitaminas y marcadores inflamatorios. Lo que la facultad enseñó a medias y la práctica exige completo.'
}, {
  icon: '📔',
  title: '04 — Abordaje en Sobrepeso y Obesidad',
  desc: 'El protocolo completo para la patología más frecuente del consultorio. Set point, neuroendocrinología del apetito, déficit moderado vs. restricción severa, manejo del estancamiento y criterios de derivación. Con el método del plato como herramienta lista para explicar en consulta.'
}, {
  icon: '📒',
  title: '05 — Diabetes y Resistencia a la Insulina',
  desc: 'El manejo nutricional de las patologías metabólicas más prevalentes en Argentina. El orden de los alimentos en el plato, el índice glucémico en la práctica real, el manejo del desayuno como comida crítica, la caminata post-comida con evidencia. Para el paciente que el médico te va a derivar más que ningún otro.'
}, {
  icon: '📓',
  title: '06 — Protocolo Cardiovascular e Hipertensión',
  desc: 'Nutrición cardioprotectora con evidencia de última generación. Dieta DASH aplicada a la alimentación argentina, reducción de sodio sin sacrificar el sabor, tabla de sodio en productos argentinos frecuentes. Para el paciente que come con sal porque "siempre lo hizo así".'
}, {
  icon: '📘',
  title: '07 — Nutrición Vegetariana y Vegana',
  desc: 'El acompañamiento del paciente con dieta basada en plantas sin juzgar su elección y sin dejar pasar los riesgos reales. B12, hierro, zinc, calcio, DHA y yodo. Por qué la espirulina no es fuente confiable de B12. Qué bebidas vegetales son útiles y cuáles son agua con sabor.'
}, {
  icon: '📗',
  title: '08 — Salud Intestinal, SIBO y Protocolo FODMAP',
  desc: 'El protocolo FODMAP completo en las 3 fases. Con tablas de alimentos adaptadas al supermercado argentino. El abordaje del SIBO desde la nutrición. La microbiota intestinal con criterio clínico. Para el paciente que vino a 5 médicos antes que a vos y todavía no sabe qué comer.'
}, {
  icon: '📙',
  title: '09 — Recetario Clínico Editable',
  desc: '40+ preparaciones terapéuticas organizadas por objetivo clínico. Con información nutricional completa, tiempo de preparación, indicaciones y contraindicaciones. Sistema de Batch Cooking dominical de 90 minutos. Listo para personalizar con tu logo y entregar en cada consulta.'
}, {
  icon: '📔',
  title: '10 — Antropometría y Valoración Nutricional',
  desc: 'Cómo medir bien y cómo comunicar los resultados de manera que el paciente se motive en lugar de frustrarse. Circunferencias, pliegues, bioimpedancia, el índice cintura/talla y cómo calcular el peso objetivo desde la masa libre de grasa real de ese paciente.'
}, {
  icon: '📒',
  title: '11 — Ciclo de Vida: Embarazo, Lactancia y Pediatría',
  desc: 'Nutrición preconcepcional, gestación trimestre a trimestre, lactancia con mitos desmentidos, Baby Led Weaning con evidencia actualizada, adolescencia con la ventana del calcio y sarcopenia en el adulto mayor con criterios EWGSOP2. Todo el ciclo. Un solo recurso.'
}, {
  icon: '📓',
  title: '12 — Psiconutrición y Coaching',
  desc: 'Las herramientas que hacen que el paciente no abandone el tratamiento. Entrevista motivacional, estadios de cambio, diario de sensaciones, mindful eating, manejo de recaídas con autocompasión, las 15 creencias limitantes más frecuentes y cuándo derivar a psicología. Porque el 95% de los fracasos no son del plan. Son del comportamiento.'
}];
export function TomosSection() {
  return <section className="py-24 bg-white" data-id="element-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-201">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-202">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-203">
            Los 12 Tomos del Sistema
          </h2>
          <p className="text-xl text-gray-600" data-id="element-204">
            Todo lo que necesitás para abordar las consultas más frecuentes con
            seguridad y respaldo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-205">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="bg-brand-sand p-8 rounded-2xl border border-gray-100 hover:shadow-lg transition-shadow" data-id="element-206">
              <div className="text-4xl mb-4" data-id="element-207">{tomo.icon}</div>
              <h3 className="text-xl font-bold text-brand-teal mb-4 leading-tight" data-id="element-208">
                {tomo.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm" data-id="element-209">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-210">
          <CtaButton data-id="element-211">Quiero llegar a cada consulta con un plan claro</CtaButton>
        </div>
      </div>
    </section>;
}